import * as React from "react";
import call from "../../call";
import axios from "axios";
import { observer } from "mobx-react";
import { modalStore, CreateTaskModalStoreContext } from "../../store";
import Box from "@mui/material/Box";
import ButtonGroup from "@mui/material/ButtonGroup";
import LoadingButton from "@mui/lab/LoadingButton";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CreateTaskModal = observer(() => {
  const createTaskModalStore = React.useContext(CreateTaskModalStoreContext);

  const handleClientChange = (event) => {
    const {
      target: { value },
    } = event;
    createTaskModalStore.setSelectedClient(
      createTaskModalStore.clients.find((client) => client.id == value),
    );
  };

  const handleCreateTask = (types) => {
    return (event) => {
      createTaskModalStore.setLoading(true);
      call(
        axios({
          method: "post",
          url: "/api/g2/task",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            client_id: createTaskModalStore.selectedClient.id,
            cids: createTaskModalStore.cids,
            date_from: createTaskModalStore.dateFrom,
            date_to: createTaskModalStore.dateTo,
          },
        }),
      )
        .then((resp) => {
          createTaskModalStore.setLoading(false);
          createTaskModalStore.setSelectedClient([]);
          createTaskModalStore.setError("");
          modalStore.closeModal();
        })
        .catch((error) =>
          createTaskModalStore.setError(error.response.data.error),
        );
    };
  };

  return (
    <div>
      <Modal
        open={true}
        onClose={() => modalStore.closeModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={MODAL_STYLE}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            {createTaskModalStore.error.length > 0 ? (
              <Alert severity="error">{createTaskModalStore.error}</Alert>
            ) : (
              ""
            )}
            <FormControl sx={{ width: "100%" }}>
              <InputLabel id="client-select-label">Client</InputLabel>
              <Select
                labelId="client-select-label"
                id="client-select"
                label="Client"
                value={createTaskModalStore.selectedClient?.id || ""}
                onChange={handleClientChange}
              >
                {createTaskModalStore.clients.map((client) => (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{ width: "100%" }}
            >
              <Autocomplete
                id="cid-chip"
                multiple
                freeSolo
                options={[]}
                value={createTaskModalStore.cids}
                onChange={
                  (e, v) => createTaskModalStore.setCids(
                    v.filter(cid => cid.trim().length > 0)
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="CIDs"
                    placeholder="Type CID here..."
                    helperText="At least 1 cid is required"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 100  // 100 is enough, currently 29 is the max length of CID in registry
                    }}
                  />
                )}
              ></Autocomplete>
            </FormControl>
            <Box sx={{ width: "100%", mb: 2 }}>
              <Typography variant="subtitle1" align="center" sx={{ mb: 1 }}>
                Select time period for the planned list
              </Typography>
              <FormControl fullWidth>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField
                    fullWidth
                    id="date-from"
                    size="small"
                    label="From"
                    type="date"
                    value={createTaskModalStore.dateFrom}
                    onChange={(e) => createTaskModalStore.setDateFrom(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    fullWidth
                    id="date-to"
                    size="small"
                    label="To"
                    type="date"
                    value={createTaskModalStore.dateTo}
                    onChange={(e) => createTaskModalStore.setDateTo(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
              </FormControl>
            </Box>
            <FormControl sx={{ width: "100%" }}>
                <ButtonGroup variant="contained">
                  <LoadingButton
                      fullWidth
                      loading={createTaskModalStore.isLoading}
                      onClick={handleCreateTask()}
                      disabled={
                          createTaskModalStore.selectedClient == null ||
                          createTaskModalStore.cids.length < 1 ||
                          !createTaskModalStore.dateFrom ||
                          !createTaskModalStore.dateTo ||
                          new Date(createTaskModalStore.dateFrom) >= new Date(createTaskModalStore.dateTo)
                      }
                  >
                      Get G2 list
                  </LoadingButton>
                </ButtonGroup>
              </FormControl>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
});
export default CreateTaskModal;
